import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createAssetsRentRequestsDocument } from '@api/assetsRentDocuments';

import { ICreateAssetRequestDocumentDTO } from '@interfaces/rent/dto/assetRentDocumentsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_REQUEST_CREATE_DOCUMENT, ASSET_REQUEST_DOCUMENTS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateAssetRequestDocument = (closeModals: () => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: createDocument,
		isLoading: isLoadingCreateDocument,
	} = useMutation<ICreateAssetRequestDocumentDTO>({
		mutationKey: [ASSET_REQUEST_CREATE_DOCUMENT],
		mutationFn: createAssetsRentRequestsDocument,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.uploadedAssetRequestDocument,
				type: ESnackbarTypes.success,
			}));

			closeModals();

			return [
				queryClient.invalidateQueries([ASSET_REQUEST_DOCUMENTS]),
			];
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.uploadErrorAssetRequestDocument,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return {
		createDocument,
		isLoadingCreateDocument,
	};
};
